import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=358031aa&"
import script from "./AdminMenu.vue?vue&type=script&lang=js&"
export * from "./AdminMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports